'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format2 = require('date-fns/format');

var _format3 = _interopRequireDefault(_format2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['position: relative;'], ['position: relative;']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 16px;\n  right: 2px;\n'], ['\n  position: absolute;\n  top: 16px;\n  right: 2px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TimePicker = require('material-ui/TimePicker');

var _TimePicker2 = _interopRequireDefault(_TimePicker);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject);

Container.displayName = 'Container';
var TimeIcon = _styledComponents2.default.span(_templateObject2);

TimeIcon.displayName = 'TimeIcon';

var NitroTimePicker = function (_Component) {
  _inherits(NitroTimePicker, _Component);

  function NitroTimePicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NitroTimePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NitroTimePicker.__proto__ || Object.getPrototypeOf(NitroTimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (event, value) {
      var valueString = (0, _format3.default)(value, 'HH:mm');
      _this.props.onChange(valueString);
    }, _this.openTimePicker = function () {
      _this.picker.openDialog();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NitroTimePicker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          value = _props.value,
          placeholder = _props.placeholder;


      var valueObject = value ? new Date('2017-01-01T' + value) : null;

      return _react2.default.createElement(
        Container,
        { className: className },
        _react2.default.createElement(_TimePicker2.default, {
          id: 'time-picker-' + placeholder,
          className: 'time-picker',
          ref: function ref(_ref2) {
            return _this2.picker = _ref2;
          },
          format: 'ampm',
          hintText: placeholder,
          value: valueObject,
          onChange: this.onChange,
          fullWidth: true
        }),
        _react2.default.createElement(
          TimeIcon,
          null,
          _react2.default.createElement(_nitroIcon2.default, { name: 'time', action: this.openTimePicker, size: 20, variant: 'secondary' })
        )
      );
    }
  }]);

  return NitroTimePicker;
}(_react.Component);

NitroTimePicker.propTypes = {
  value: _propTypes2.default.string,
  action: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  className: _propTypes2.default.string
};

exports.default = NitroTimePicker;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-time-picker/NitroTimePicker.js
// module id = 3046
// module chunks = 4